/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Cashback AutoSpending component
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { Typography } from '@nexign/scc-ui-kit';

import { IPageCashbackTranslation } from '@/main/modules/internationalization/types/pages/cashback';

import { fonts } from '../../../../theme';
import { CashbackServiceInfoStyled } from '../styled/CashbackControlStyled'
import { CashbackTextStyled } from '../styled/CashbackStyled'

interface ICashbackServicesInfoProps {
    translationCashback: IPageCashbackTranslation;
}

export const CashbackServicesInfo = (props: ICashbackServicesInfoProps) => {
    const { translationCashback } = props;
    return (
        <CashbackServiceInfoStyled className="cashback-control__cashback-services-info">
            <CashbackTextStyled
                className="cashback-services-info__title"
                font={fonts.textHeader3}
            >
                {translationCashback.cashbackServiceInfo.title}
            </CashbackTextStyled>
            <CashbackTextStyled className="cashback-services-info__subtitle">
                <Typography isDangerousInnerHTML>
                    {translationCashback.cashbackServiceInfo.infoHtmlText}
                </Typography>
            </CashbackTextStyled>
        </CashbackServiceInfoStyled>
    )
}
